import { render, staticRenderFns } from "./Telemedicine.vue?vue&type=template&id=b4ba71e4"
import script from "./Telemedicine.vue?vue&type=script&lang=js"
export * from "./Telemedicine.vue?vue&type=script&lang=js"
import style0 from "./Telemedicine.vue?vue&type=style&index=0&id=b4ba71e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports